export enum VstoreIdE {
    all = '-1',
    sys = '0'
}
